import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">Refund Policy</h1>
          <p className="text-sm text-gray-500 mb-8"><strong>Effective Date:</strong> January 1, 2025</p>

          <div className="prose prose-gray max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Beta V1 Lifetime Access</h2>
            <p className="text-gray-700 mb-6">
              For our Beta V1 offering ($97 one-time payment), we offer a 72-hour money-back guarantee. If you are not satisfied with the service within 72 hours (3 days) of purchase, you may request a full refund.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Refund Eligibility</h2>
            <p className="text-gray-700 mb-4">To be eligible for a refund, you must:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Request the refund within 72 hours (3 days) of your purchase date</li>
              <li>Provide a valid reason for your refund request</li>
              <li>Not have violated our Terms of Use</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Non-Refundable Services</h2>
            <p className="text-gray-700 mb-4">The following are not eligible for refunds:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Managed services after work has commenced</li>
              <li>Custom research reports after delivery</li>
              <li>Refund requests made after the 72-hour period</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. How to Request a Refund</h2>
            <p className="text-gray-700 mb-4">To request a refund:</p>
            <ol className="list-decimal pl-6 mb-6 text-gray-700 space-y-2">
              <li>Email us at <a href="mailto:support@salesqualifyd.com" className="text-red-800 hover:text-red-900">support@salesqualifyd.com</a></li>
              <li>Include your account email and transaction details</li>
              <li>Provide a brief explanation for your refund request</li>
            </ol>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Refund Processing</h2>
            <p className="text-gray-700 mb-4">Once your refund request is approved:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-700 space-y-2">
              <li>Refunds will be processed within 5-7 business days</li>
              <li>The refund will be issued to your original payment method</li>
              <li>Your account access will be terminated upon refund processing</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Managed Services</h2>
            <p className="text-gray-700 mb-6">
              For managed services clients, refund terms are defined in your service agreement. Please refer to your contract or contact your account manager for details.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Payment Provider Fees</h2>
            <p className="text-gray-700 mb-6">
              Please note that payment processing fees charged by PayPal or Razorpay are non-refundable.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-gray-700 mb-4">
              If you have questions about our refund policy, please contact:
            </p>
            <div className="bg-gray-50 rounded-lg p-6 mb-6">
              <p className="font-semibold text-gray-900 mb-2">BALLSPARK TECHNOLOGIES PRIVATE LIMITED</p>
              <p className="text-gray-700 text-sm space-y-1">
                Suite #315 Viya Workspaces<br />
                36/1, Raghav Towers<br />
                Amman Nagar, Saravanampatti<br />
                Coimbatore 641035<br />
                <br />
                Phone: <a href="tel:+919789499945" className="text-red-800 hover:text-red-900">+91 97894 99945</a><br />
                Email: <a href="mailto:support@salesqualifyd.com" className="text-red-800 hover:text-red-900">support@salesqualifyd.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-6 md:py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs sm:text-sm text-gray-400">
            © 2025 BALLSPARK TECHNOLOGIES PRIVATE LIMITED. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
